import { useContext, useMemo } from "react";
import type { i18n, TOptions } from "i18next";
import { I18nContext } from "./context";

interface I18nTranslation extends Omit<i18n, "t"> {
  t: (key: string, options?: TOptions) => string;
  tArray: <T>(key: string) => T[];
}

export const useI18n = (): i18n => useContext(I18nContext);

export const useTranslation = (): I18nTranslation => {
  const i18n = useContext(I18nContext);
  const { t } = i18n;

  return useMemo<I18nTranslation>(() => {
    const tFunction = (key: string, options?: TOptions): string => t(key as any, options) as string;
    const tArray = <T>(key: string): T[] => i18n.t(key as any, { returnObjects: true }) as unknown as T[];
    return {
      ...i18n,
      t: tFunction,
      tArray,
    };
  }, [i18n, t]);
};
